import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { useDefaultCurrency } from "@/routes/_layout/quoting_/quotes/-lib/default-currency"
import { savedMessage, TaskPanel } from "../-components/task-panel"

export const Route = createFileRoute("/_layout/templates/tasks/create")({
  staticData: { detailSidebar: true },
  component: CreateTemplateTask,
})

function CreateTemplateTask(): React.ReactElement | null {
  const currency = useDefaultCurrency()
  const navigate = useNavigate()
  const showToast = useCustomToast()

  if (currency === undefined) return null

  return (
    <TaskPanel
      task={null}
      currency={currency}
      onSaved={(saved) => {
        showToast("Created", savedMessage(saved), "success")
        void navigate({
          to: "/templates/tasks/$taskId",
          params: { taskId: saved.id },
          search: true,
          replace: true,
        })
      }}
      onClose={() => navigate({ to: "/templates/tasks", search: true })}
    />
  )
}
